import { takeEvery, call, put } from 'redux-saga/effects';
import {
    fetchSupportTicketsStart,
    fetchSupportTicketsSuccess,
    fetchSupportTicketsFail,
    updateSupportTicketStart,
    updateSupportTicketSuccess,
    updateSupportTicketFail,
} from '../slices/supportTicketSlice';
import { getRequest, patchRequest } from '../../network';
import { getSupportTickets, updateSupportTicket } from '../apis';

function* fetchTicketsSaga(action) {
    try {
        const response = yield call(getRequest, getSupportTickets, action.payload);
        yield put(fetchSupportTicketsSuccess(response));
    } catch (error) {
        yield put(fetchSupportTicketsFail(error.message));
    }
}

function* updateTicketSaga(action) {
    try {
        const { id, data, callback } = action.payload;
        const response = yield call(patchRequest, updateSupportTicket.replace(':id', id), data);
        if (callback) {
            callback(null, response);
        }
        yield put(updateSupportTicketSuccess(response));
    } catch (error) {
        if (action.payload?.callback) {
            action.payload.callback(error.message);
        }
        yield put(updateSupportTicketFail(error.message));
    }
}

export function* watchSupportTickets() {
    yield takeEvery(fetchSupportTicketsStart.type, fetchTicketsSaga);
    yield takeEvery(updateSupportTicketStart.type, updateTicketSaga);
}

